import React from 'react';
import { RELATIONSHIP_OPTIONS } from '../constants';

export function AddProxyModal({ 
  show, 
  proxyName, 
  setProxyName, 
  proxyEmail, 
  setProxyEmail, 
  proxyRelationship, 
  setProxyRelationship, 
  adding, 
  onSubmit, 
  onClose 
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="add-proxy-modal">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">Add Family Member (No Account)</h3>
        <p className="text-gray-600 mb-4">Add someone who doesn't have a Legacy Forge Family account. You can RSVP on their behalf for events.</p>
        
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Name *</label>
            <input
              type="text"
              value={proxyName}
              onChange={(e) => setProxyName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              placeholder="e.g., Grandma Rose"
              required
              data-testid="proxy-name-input"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Email (optional)</label>
            <input
              type="email"
              value={proxyEmail}
              onChange={(e) => setProxyEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              placeholder="e.g., grandma@email.com"
              data-testid="proxy-email-input"
            />
            <p className="text-xs text-gray-500 mt-1">Optional: Add their email to send them event notifications</p>
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Relationship *</label>
            <select
              value={proxyRelationship}
              onChange={(e) => setProxyRelationship(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              required
              data-testid="proxy-relationship-select"
            >
              {RELATIONSHIP_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          <div className="flex space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={adding}
              className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
              data-testid="submit-proxy-btn"
            >
              {adding ? 'Adding...' : 'Add Member'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
